module.exports = __webpack_public_path__ + "img/top-seller.f5ed39d4.png";